
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

function UUIDGenerator() {
  const [uuid, setUUID] = React.useState('');

  const generateUUID = () => {
    setUUID(uuidv4());
  };

  return (
    <div className="encoder-decoder" id="UUIDGenerator">
      <h2>UUID Generator</h2>
       <div className="description-section">
           <p>
Our UUID Generator allows you to quickly generate unique identifiers (UUIDs) for your applications. UUIDs are essential for assigning unique IDs to data, ensuring no two identifiers are the same. This tool supports different UUID versions, offering flexibility depending on your project requirements. With just one click, generate UUIDs for database entries, object identifiers, and more.
        </p>
          </div>
      <button className ="beautify-button" onClick={generateUUID}>Generate UUID</button>
      <p>{uuid}</p>
    </div>
  );
}

export default UUIDGenerator;
